import { Component, OnInit,Input} from '@angular/core';
import { Location } from '@angular/common';
import { FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-office-container',
  templateUrl: './office-container.component.html',
  styleUrls: ['./office-container.component.scss']
})
export class OfficeContainerComponent implements OnInit {
  form: FormGroup;
  @Input() projectId:number;

  constructor(
    private location: Location,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
  // console.log(this.projectId);

      this.form = this.formBuilder.group({
        size:[null,Validators.required],
        rate:[null,Validators.required],
        agancy_name:[null,Validators.required],
        agancy_contact_number:[null,Validators.required],
        agancy_contact_name:[null,Validators.required],
        transportation_cost:[null,Validators.required],
        start_date:[null,Validators.required],
        end_date:[null,Validators.required],
        budgeted_cost:[null,Validators.required],
        executed_cost:[null,Validators.required],
        documents:this.formBuilder.array([
          this.createDocument()
        ])
    })
  }

  createDocument(){
    return this.formBuilder.group({
      document_name: ['', Validators.required],
      upload_file: [null, Validators.required],
      electrical_document: null
    })
  }

  getFormArrayControl(form) {
    return form.get('documents').controls
  }

  addDocument()
  {
    const control = <FormArray>this.form.controls['documents'];
    control.push(this.createDocument());
  }

  deleteDocument(index:number)
  {
    const control = <FormArray>this.form.controls['documents'];
    control.removeAt(index);
  }

  submit()
  {
    if(this.form.valid){
      //console.log(this.form.value);
    }else
    {
      this.markFormGroupTouched(this.form);
    }
  }

  onSelectFile(event, index){
    //console.log(event.target.files);
    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        var reader = new FileReader();
        reader.onload = (event) => {
          // console.log(event.target['result']);
        }
        const control = <FormArray>this.form.controls['documents'];
        control.at(index).patchValue({
          upload_file: event.target.files[0]['name'],
          electrical_document: event.target.files[0]
        })
        reader.readAsDataURL(event.target.files[i]);
      }
    }
  }

  markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        control.controls.forEach(c => this.markFormGroupTouched(c));
      }
    });
  }

  isFieldValid(form: FormGroup, field: string) {
    return !form.get(field).valid && (form.get(field).dirty || form.get(field).touched);
  }

  displayFieldCss(form: FormGroup, field: string) {
    return {
      'is-invalid': form.get(field).invalid && (form.get(field).dirty || form.get(field).touched),
      'is-valid': form.get(field).valid && (form.get(field).dirty || form.get(field).touched)
    };
  }

  

}
